import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { MyPlayLoader, DarkScreenMask, ConfirmModal } from '@myplay/ui';

import I18N from '../../I18N';
import { capitalize } from '../../utils/stringManipulations';
import { SingleSite, HeaderTiles } from '../../components';
import './Sites.scss';

const Sites = ({ SitesStore }) => {
  const { isLoadingSites } = SitesStore;
  const [taskToDelete, setTaskToDelete] = useState(null);

  const handleDeleteTask = async ()=> {
    const { _id, siteId } = taskToDelete;
    await SitesStore.cancelTask(_id, siteId);
    setTaskToDelete(null);
  }

  const handleSetTaskToDelete = (task, siteId) => {
    setTaskToDelete({
      ...task, 
      siteId
    });
  }

  return (
    <div className="sites" data-testid="sites">
      {isLoadingSites ?
        <div className="sites__loader-container">
          <MyPlayLoader color="#fff" />
        </div> :
        <Fragment>
          <div className="sites__header">
            <div className="sites__header__title">{I18N.t("SITES").toUpperCase()}</div>
            <HeaderTiles />
          </div>
          <div className="sites__sites-container">
            {SitesStore.sites.map(site =>
              <div key={site._id} className="sites__sites-container__site">
                <SingleSite
                  key={site.name}
                  site={site}
                  onDeleteTask={handleSetTaskToDelete}
                />
              </div>
            )}
          </div>
        </Fragment>
      }
      <DarkScreenMask isVisible={!!taskToDelete}>
        <ConfirmModal
          onApprove={handleDeleteTask}
          onDismiss={() => setTaskToDelete(null)}
          title={capitalize(I18N.t("DELETE_SCHEDULED_TASK_CONFIRMATION"))}
        />
      </DarkScreenMask>
    </div>
  );
};

Sites.propTypes = {
  MetricsStore: PropTypes.object,
  SitesStore: PropTypes.object
};

Sites.defaultProps = {
  MetricsStore: {}, 
  SitesStore: {}
};

export default inject("SitesStore")(observer(Sites));
